/**
 * PhaseNavigation
 */
import React from 'react';
/** Navigation to next/previous phase. */
var PhaseNavigation = function (_a) {
    var children = _a.children, className = _a.className, _b = _a["aria-label"], ariaLabel = _b === void 0 ? 'Navigera till nästa/tidigare fas' : _b;
    return (React.createElement("nav", { "aria-label": ariaLabel, className: className, "data-cid": "PhaseNavigation" },
        React.createElement("ul", null, children)));
};
export default PhaseNavigation;
